<rappider-ui-data-update-function-page [config]="listConfig"
                                       [uiDataUpdateFunctions]="uiDataUpdateFunctions"
                                       [loading]="loading"
                                       (uiDataUpdateFunctionCreate)="onCreateUpdateFunction()"
                                       (uiDataUpdateFunctionDelete)="deleteUIDataUpdateFunction($event)">
</rappider-ui-data-update-function-page>
